import { mount } from "svelte";
import "../agent_page_app/app.postcss";   // CSS global del proyecto (queuereport_agent.css)
import "../lib/theme.js";   // aplica data-bs-theme (claro/oscuro) antes de montar
import App from "./App.svelte";

const app = mount(App, {
  target: document.getElementById("app"),
});

export default app;
